<div class="title">{{ fastingDays }} روز مورد نظر جهت فستینگ انتخاب کنید</div>
<div class="container">
  <app-radio-button
    *ngFor="let configButton of configButtons"
    [config]="configButton"
  ></app-radio-button>
</div>
